// extracted by mini-css-extract-plugin
module.exports = {"jim":"NousRejoindre_jim__3hb8e","type":"NousRejoindre_type__2P9Fx","green":"NousRejoindre_green__dP8nB","bigContenaire":"NousRejoindre_bigContenaire__EPI2R"};